import { createApp } from "vue";
import "element-plus/dist/index.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import router from "./router/index";
import App from "./App.vue";
import store from "./store/index";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "./assets/styles/app.scss";
import "bootstrap/dist/css/bootstrap.css";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.js";
import mitt from "mitt";
import VueTimezoneSelect from "vue-timezone-select";
import authentication from "./middlewares/authentication.js";
const emitter = mitt();
const app = createApp(App);
app.config.globalProperties.emitter = emitter;
app.use("store", store);
app.use(router);
app.use(store);
app.use(ElementPlus);
app.use(bootstrap);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
const publicPages = ["/", "/signup", "/sso-signIn"];
const redirectIfAuthenticated = ["/", "/signup"];

router.beforeEach(async (to, from, next) => {
  await store.dispatch("globalApis/updateCurrentNavigationPath", to.fullPath);
  const authRequired = !publicPages.includes(to.path);
  const isAuthenticated = authentication.isAuthenticated();
  if (!isAuthenticated && authRequired) {
    if (to.query?.sso === "true") {
      const queryString = new URLSearchParams(to.query).toString();
      const fullPath = `${to.path}${queryString ? "?" + queryString : ""}`;
      const ssoRedirect = `${
        process.env.VUE_APP_AUTHFAST_URL
      }/signin/client?redirect_url=${encodeURIComponent(
        process.env.VUE_APP_REDIRECT_URI
      )}&state=${encodeURIComponent(fullPath)}`;
      window.open(ssoRedirect, "_self");
    } else {
      next("/");
    }
  } else if (isAuthenticated && redirectIfAuthenticated.includes(to.path)) {
    next("/connector");
  } else {
    next();
  }
});

app.component("vue-timezone-select", VueTimezoneSelect);
app.mount("#app");
